import React from 'react';
import PropTypes from 'prop-types';

import './CalendarIcon.scss';

const CalendarIcon = ({ value, width, height }) => (
  <svg
    viewBox="0 0 40 40"
    className="calendar-icon"
    width={width || 40}
    height={height || 40}
  >
    <g>
      <circle r="46%" cx="50%" cy="50%" />
      <path
        className={value ? 'numbered-calendar' : 'full-calendar'}
        x="50%"
        d="M21 11V9.1h-1.6V11h-6.8V9.2H11V11H9.2v11.8h13.6V11H21zm0 10H11v-5h10v5zm0-6.7H11v-1.7h10v1.7zm-8.4 3.4h1.7v1.7h-1.7v-1.7zm2.6 0h1.6v1.7h-1.6v-1.7zm2.5 0h1.7v1.7h-1.7v-1.7z"
      />
      <text x="50%" y="80%">
        {value}
      </text>
    </g>
  </svg>
);

CalendarIcon.propTypes = {
  value: PropTypes.string,
};

export default CalendarIcon;
